import { apiAction } from './api';
import endpoints from './endpoints';

export const SET_KPI_DETAILS = 'SET_TASKSET_KPI_DETAILS';

export const getKpiDetails = (timecardId) => {
  return apiAction({
    url: endpoints.getKpiDetails,
    data: { timecardId },
    onSuccess: [setKpiDetails],
  });
};

export const setKpiDetails = (data) => {
  return {
    type: SET_KPI_DETAILS,
    payload: data,
  };
};

const initialState = {
  timecard: null,
  lastTimecard: null,
  last30days: null,
  last90days: null,
};

const kpiDetails = (state = initialState, action) => {
  switch (action.type) {
    case SET_KPI_DETAILS:
      return action.payload;
    default:
      return state;
  }
};
export default kpiDetails;
